import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {IInquiryCndsState, ICom0102MState, IDeptListItemState, IDeptCdState, IDeptStCdState} from '../../models/com/com0102m_model';
  
const initialState: ICom0102MState = {
    deptDatas: [],      // 부서목록(조회결과)
    deptCdList: [],     // 부서코드
    deptStCdList: [],   // 부서상태코드

    /* 조회조건 */
    inquiryCnds: {
        deptCd      : '',   // 부서코드 
        deptStCd    : '',   // 부서상태코드     
    },

    pageSize  : 20,     // 페이징건수
    current   : 0,
}

export const com0102m_Slice = createSlice({
    name: "com0102m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , deptCdList: state.deptCdList
                                   , deptStCdList: state.deptStCdList});
        },
        setDeptDatas: (state, action:PayloadAction<IDeptListItemState[]>) => {
            state.deptDatas = action.payload;
        },
        setDeptCdList: (state, action:PayloadAction<IDeptCdState[]>) => {
            state.deptCdList = action.payload;
        },
        setDeptStCdList: (state, action:PayloadAction<IDeptStCdState[]>) => {
            state.deptStCdList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default com0102m_Slice.reducer;
export const Com0102mAction  = com0102m_Slice.actions;
export const Com0102mReducer = com0102m_Slice.reducer;